module.exports = __webpack_public_path__ + "static/Szkic-74a27f58e9f3e1ad6d6297f8bd95aeff.jpg";